import React, { useMemo, useCallback } from 'react';
import { CONTENT_TYPE_LIST_QUERY } from '../queries';
import { ExportModalComponent } from 'components/common/export/ExportModalComponent';
import { Card } from '@totalsoft/rocket-ui';
import ListAltIcon from '@mui/icons-material/ListAlt';
import TableListBrowser from 'features/common/components/table-list-browser/TableListBrowser';
import ContentTypesComponent from './ContentTypesComponent';
import ApolloFetchingComponent from 'features/common/components/apollo-fetching/ApolloFetchingComponent';
import { contentTypeStore } from '../contentTypeStore';
import { useMutation } from 'hooks/apollo/useMutation';
import { DELETE_CONTENT_TYPE } from '../mutations';
import useConfirmDialog from 'features/common/components/confirm/useConfirmDialog';
import { CONTENT_TYPE_DELETED } from '../subscriptions';
import { useToast } from 'hooks/toasts/useToast';
import { useTranslation } from 'react-i18next';
import useSubscription from 'hooks/apollo/useSubscription';

const ContentTypesListBrowser = () => {
  const addToast = useToast();
  const confirm = useConfirmDialog();
  const { t } = useTranslation();

  const fetchingOptions = useMemo(
    () => ({
      queryOptions: {
        query: CONTENT_TYPE_LIST_QUERY,
        name: 'contentTypeList'
      }
    }),
    []
  );

  const columns = useMemo(
    () => [
      { name: 'code', caption: 'ContentTypes.Code' },
      { name: 'name', caption: 'ContentTypes.Name' },
      { name: 'isFileType', caption: 'ContentTypes.IsFile', width: 15, align: 'center' },
      { name: 'actions', caption: 'Actions', width: 15 }
    ],
    []
  );

  // #region Delete

  const [deleteContentType] = useMutation(DELETE_CONTENT_TYPE);

  const handleDelete = useCallback(
    id => {
      confirm(
        () => {
          deleteContentType({ variables: { id } });
        },
        {
          content: t('ContentTypes.AreYouSureDeleteContentType')
        }
      );
    },
    [confirm, t, deleteContentType]
  );

  useSubscription(CONTENT_TYPE_DELETED, {
    onData: ({ client }) => {
      addToast(t('ContentTypes.ContentTypeDeleted'), 'success');
      client.cache.evict({ id: 'ROOT_QUERY', fieldName: 'contentTypeList' });
      client.cache.gc();
    }
  });

  // #endregion

  const itemComponent = useCallback(({ data }) => <ContentTypesComponent data={data} onDelete={handleDelete} />, [handleDelete]);

  return (
    <Card icon={ListAltIcon}>
      <TableListBrowser name='content-types-browser' store={contentTypeStore} ItemComponent={itemComponent} columns={columns} />
      <ExportModalComponent store={contentTypeStore} options={fetchingOptions} />
      <ApolloFetchingComponent store={contentTypeStore} options={fetchingOptions} />
    </Card>
  );
};

export default ContentTypesListBrowser;
